import { createAsyncThunk } from '@reduxjs/toolkit';

import { authService } from 'services';

export const signOut = createAsyncThunk(
  'auth/signOut',
  async (_, { rejectWithValue }) => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');

      if (refreshToken) {
        await authService.signOut(refreshToken);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
      }
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
